<template>
  <div class="basic-info" id="basic-info">
    <!-- <van-nav-bar
      :title="navTitle"
      left-arrow
      @click-left="onClickLeft"
      fixed
      placeholder
    /> -->
    <div class="basic-info-box">
      <div class="box-title">{{ navTitle }}</div>
      <div class="box-file" v-for="(item, index) of list" :key="index">
        <appoint-file-upload
          :title="item.ZLMC"
          v-model="item.FJLIST"
          :serialNo="index + 1"
          :content="item.ZLSM"
          :isCheck="item.SFBX == '是'"
        ></appoint-file-upload>
      </div>
    </div>
    <div class="btn-group">
      <van-button plain type="info" @click="toPrev">上一步</van-button>
      <van-button type="info" class="btn" @click="saveData(2)">暂存</van-button>
      <van-button type="info" @click="toNext">下一步</van-button>
    </div>
    <!--弹窗-->
    <van-dialog v-model="showDialog" show-cancel-button confirm-button-color="#1D84FF" confirm-button-text="下一步" @confirm="next">
      <div style="display: flex;padding: 20px 10px 10px 20px;">
      <van-icon style="margin-top: 4px" name="info-o" size="19" color="#ffa403" />
      <div style="padding-left: 10px; font-weight: 500;">
        <div style="font-size: 18px;">必需材料未上传</div>
        <div style="font-size: 14px;padding-top: 10px;">点击【取消】可继续上传</div>
        <div style="font-size: 14px;padding-top: 10px;">未上传材料可后续在系统中补齐</div>
      </div>
    </div>
    </van-dialog>
  </div>
</template>

<script>
import AppointFileUpload from "@/components/ProjectAppoint/appoint-file-upload.vue";
import appointMixins from "@/mixins/appointMixins";
import moduleMixins from "@/mixins/moduleMixins";
import api from "@/utils/api/appoint";
import { mapState, mapGetters,mapMutations } from "vuex";

export default {
  name: "FileTable",
  components: { AppointFileUpload },
  mixins: [moduleMixins, appointMixins],
  props: {},
  data() {
    return {
      showContract: false,
      value: true,
      list: [],
      showDialog: false,
      rid:this.$route.params.id
    };
  },
  watch: {
    showContract: {
      handler(val) {
        if (val) {
          this.prevent_back();
        } else {
          this.remove_back();
        }
      },
    },
  },
  computed: {
    ...mapState("form", ["formData"]),
    ...mapGetters("form", ["getFormConfigByName"]),
    isCheck() {
      let isRule = true;
      for (let data of this.list) {
        if (data.SFBX == "是" && data.FJLIST.length == 0) {
          isRule = false;
        }
      }
      return isRule;
    },
    navTitle() {
      return "材料上传";
    },
  },
  methods: {
    ...mapMutations("form",['setFormConfig','setFormConfigPermission']),
    toNext() {
      if (this.isCheck) {
        //直接去下一步
        this.next()
      } else {
        //false 材料没全部上传
        this.showDialog = true;
      }
    },
    toPrev(){
      // this.onClickLeft()
      this.$router.push({name:'ProjectAppointOrgan'})
    },
    saveData(){
      this.$store.commit("form/setFormData", { 'FileTable': this.list });
      this.saveTempData('FileTable')
    },
    next(){
      //保存到vuex
      this.$store.commit("form/setFormData", { 'FileTable': this.list });
      this.$router.push({
        name: "projectAppointInfoConfirm",
      });
    },
    loadData() {
      const formConfig = this.getFormConfigByName("CascaderSelect").data;
      const XZQCode = this.getFormConfigByName('CommonFormFinal').data.XZQCode
      const files = this.getFormConfigByName('FileTable').data.files
      let wtsx = [];
      formConfig.CLSX.forEach((element) => {
        wtsx.push(element.CLSXCode);
      });
      api.getAppointProvideFileList({ sWTSX: wtsx.join(";"),xzq:XZQCode }).then((res) => {
        res.data.rowsList.forEach((element) => {
          if(files){
            //vuex保存的数据
            const oldFile= files.filter(item=>item.ZLMC == element.ZLMC)
            if(oldFile.length>0){
              element.FJLIST = oldFile[0].FJLIST
            }else{
              element.FJLIST = [];
            }
          }else{
            element.FJLIST = [];
          }
        });
        this.list = res.data.rowsList;
      });
    },
  },
  created() {},
  mounted() {
    // if(this.rid){
    //   //编辑功能，用rid获取之前保存的数据
    //   api.getDataByTemporarilyToCode({rid:this.rid}).then(res=>{
    //     this.setFormConfig(JSON.parse(res.data))
    //     //为了获取最新的委托信息控件
    //     api.getComponentConfig().then(res=>{
    //       this.setFormConfigPermission({'CommonFormFinal':res.data[1].permission})
    //     })
    //     this.loadData()
    //   })
    // }else{
      this.loadData();
    // }
  },
};
</script>
<style lang="scss" scoped>
.basic-info {
  height: 100%;
  background: #ffffff;
  &.noScroll {
    overflow: hidden;
    height: 100vh;
  }
  .basic-info-box {
    padding: 10px 15px;
    .box-title {
      font-size: 17px;
      font-weight: bold;
      color: #333333;
      padding: 10px 0px;
    }
    .box-file {
      margin-bottom: 20px;
    }
    .tips {
      font-size: 14px;
      font-weight: 500;
      color: #333333;
      padding-top: 10px;
      span {
        color: #1d84ff;
        text-decoration: underline;
      }
    }
    .project-service {
      padding: 10px 10px;
      border: 1px solid #dddddd;
      .service-title {
        font-size: 14px;
        padding: 10px 0px;
        font-weight: bold;
        color: #333333;
      }
      .checkbox {
        padding: 10px 0px;
        font-size: 14px;
        color: #333333;
      }
    }
    .no-btn {
      background: #cfcfcf;
      box-shadow: 0px 2px 6px 0px rgba(207, 207, 207, 0.5);
      border-radius: 5px;
      padding: 14px 0;
      font-size: 14px;
      font-weight: 500;
      color: #ffffff;
      border: 1px solid transparent;
      margin-top: 20px;
      text-align: center;
    }

    .btn {
      background: #0086ff;
      box-shadow: 0px 2px 6px 0px rgba(29, 132, 255, 0.5);
      border-radius: 5px;
      font-size: 14px;
      font-weight: 500;
      color: #ffffff;
      padding: 14px 0;
      border: 1px solid transparent;
      margin-top: 20px;
      text-align: center;
    }
    .picker {
      ::v-deep .van-picker__toolbar {
        border-bottom: 1px solid #dddddd;
      }
      ::v-depp .van-picker__confirm {
        color: #1d84ff;
      }
      ::v-deep .van-picker-column__item {
        color: #999999;
      }
      ::v-deep .van-picker__cancel {
        color: #999999;
      }
      ::v-deep .van-picker__mask {
        background-image: none;
      }
      ::v-deep .van-picker-column__item--selected {
        color: #1d84ff;
      }
    }
  }
  .btn-group {
    width: 100%;
    padding: 10px 0;
    text-align: center;
    background-color: #fff;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-around;
    // box-shadow: 0px -5px 5px -5px #ccc;
    border-top: 1px solid #eee;
    .btn {
      padding: 14px 20px;
      font-weight: 500;
      color: #ffffff;
      border: 1px solid transparent;
    }
  }
}
</style>
